module.exports = "https://s3-us01.didiglobal.com/ibt-mobility-fe-static/driver-page/register/bitmap@3x.20a53083.png";